import { Reducer } from "redux";

import { RationaleTemplateResponse } from "../models/Api/RationaleTemplate";
import { RationaleTemplateDispatchTypes } from "../models/DispatchTypes/RationaleTemplate";
import { RationaleTemplateActionDispatchTypes } from "../constants/RationaleTemplate";

export const initialState: RationaleTemplateResponse = {
  loading: false,
  response: {
    rationaleTemplateId: "-1",
    serviceRequestType: "",
    rationaleDecision: "",
    discipline: "",
    rationale: "",
    templateName: "",
    resourceDescription: "",
    isActive: false,
    userCreated: ""
  },
};

const RationaleTemplateReducer: Reducer<
  RationaleTemplateResponse,
  RationaleTemplateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RationaleTemplateActionDispatchTypes.GET_RATIONALE_TEMPLATE_FORM_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RationaleTemplateActionDispatchTypes.GET_RATIONALE_TEMPLATE_FORM_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case RationaleTemplateActionDispatchTypes.GET_RATIONALE_TEMPLATE_FORM_RESET: {
      return {
        response: initialState.response,
        loading: false,
      };
    }
  }
  return state;
};

export default RationaleTemplateReducer;
